import { render } from "./UiSpin.vue?vue&type=template&id=be4e1a50&ts=true"
import script from "./UiSpin.vue?vue&type=script&lang=ts"
export * from "./UiSpin.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__